import gql from "graphql-tag";

export const USER_QUERY = gql`
  query UserByIdQuery($id: ID!) {
    user(where: { id: $id }) {
      id
      email
      ldapDN
      name
      firstName
      surName
      phone
      postalCode
      city
      street
      roles {
        name
      }
      lastLoginAt
      lockedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/screens/User/queries.ts